/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FleetAuthenticatePeriodList
 */
export interface FleetAuthenticatePeriodList {
    /**
     * 
     * @type {boolean}
     * @memberof FleetAuthenticatePeriodList
     */
    eventId: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FleetAuthenticatePeriodList
     */
    userEmployeeId: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FleetAuthenticatePeriodList
     */
    vehicleSerialNumber: boolean;
}

/**
 * Check if a given object implements the FleetAuthenticatePeriodList interface.
 */
export function instanceOfFleetAuthenticatePeriodList(value: object): value is FleetAuthenticatePeriodList {
    if (!('eventId' in value) || value['eventId'] === undefined) return false;
    if (!('userEmployeeId' in value) || value['userEmployeeId'] === undefined) return false;
    if (!('vehicleSerialNumber' in value) || value['vehicleSerialNumber'] === undefined) return false;
    return true;
}

export function FleetAuthenticatePeriodListFromJSON(json: any): FleetAuthenticatePeriodList {
    return FleetAuthenticatePeriodListFromJSONTyped(json, false);
}

export function FleetAuthenticatePeriodListFromJSONTyped(json: any, ignoreDiscriminator: boolean): FleetAuthenticatePeriodList {
    if (json == null) {
        return json;
    }
    return {
        
        'eventId': json['eventId'],
        'userEmployeeId': json['userEmployeeId'],
        'vehicleSerialNumber': json['vehicleSerialNumber'],
    };
}

export function FleetAuthenticatePeriodListToJSON(json: any): FleetAuthenticatePeriodList {
    return FleetAuthenticatePeriodListToJSONTyped(json, false);
}

export function FleetAuthenticatePeriodListToJSONTyped(value?: FleetAuthenticatePeriodList | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'eventId': value['eventId'],
        'userEmployeeId': value['userEmployeeId'],
        'vehicleSerialNumber': value['vehicleSerialNumber'],
    };
}

